export const AFFILIATE_COOKIE_KEYS = {
  AFFILIATE_CODE: 'nnet_affiliate_code',
  AFFILIATE_VISITOR_ID: 'nnet_affiliate_visitor_id',
} as const;
